import { render, staticRenderFns } from "./DepartmentSet.vue?vue&type=template&id=27c9c08b&scoped=true&"
import script from "./DepartmentSet.vue?vue&type=script&lang=js&"
export * from "./DepartmentSet.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentSet.vue?vue&type=style&index=0&id=27c9c08b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c9c08b",
  null
  
)

export default component.exports